/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumFileCartellaDtoTipo =
  (typeof EnumFileCartellaDtoTipo)[keyof typeof EnumFileCartellaDtoTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumFileCartellaDtoTipo = {
  GRUPPO_ALLEGATO: 'GRUPPO_ALLEGATO',
  ALLEGATI_RICHIESTA: 'ALLEGATI_RICHIESTA',
  COMUNICAZIONE: 'COMUNICAZIONE',
  DOCUMENTO: 'DOCUMENTO',
} as const;
